module.exports = __webpack_public_path__ + "img/antes_despues_305.58eeb564.png";